export class ContactoModel {
  id: number = 0;
  nombre: string = '';
  apellidos: string = '';
  cargo: string = '';
  disciplinaProfesional: string = '';
  telefono: string = '';
  telMovil: string = '';
  email: string = '';
  direccion: string = '';
  localidad: string = '';
  comunidadAutonomaId?: number = null;
  provinciaId?: number = null;
  codPostal: string = '';
  pais: string = '';
  isNuevo: boolean = false;
  tempId: string = '';
}